(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-nav-link]').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((group) => {
    const input = group.querySelector('input[type="number"]');
    group.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.quantityChange);
        const next = Math.max(Number(input.min || 1), Number(input.value || 1) + direction);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-variant-selector]').forEach((selector) => {
    const productInfo = selector.closest('.product-info');
    if (!productInfo) return;

    const updateVariantDetails = () => {
      const option = selector.options[selector.selectedIndex];
      if (!option) return;

      const price = productInfo.querySelector('[data-price] .price__current');
      const comparePrice = productInfo.querySelector('[data-price] .price__compare');
      const addButton = productInfo.querySelector('[data-add-to-cart]');
      const selectedSize = productInfo.querySelector('[data-selected-size]');
      const available = option.dataset.available === 'true';

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (comparePrice) comparePrice.hidden = true;
      if (selectedSize) selectedSize.textContent = option.textContent.replace(/\s*—\s*Sold out\s*$/, '').trim();
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'Sold out';
      }
    };

    selector.addEventListener('change', updateVariantDetails);
    updateVariantDetails();
  });

  if (!reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('[data-reveal]').forEach((item) => observer.observe(item));
  } else {
    document.querySelectorAll('[data-reveal]').forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-accordion]').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      const parent = details.parentElement;
      parent.querySelectorAll('[data-accordion][open]').forEach((sibling) => {
        if (sibling !== details) sibling.removeAttribute('open');
      });
    });
  });

  const checkout = document.getElementById('NanawalaCheckout');
  const checkoutStatus = document.querySelector('[data-checkout-status]');
  let latestCart = null;
  let statusTimer = null;

  const showCheckoutStatus = (message) => {
    if (!checkoutStatus) return;
    checkoutStatus.textContent = message;
    checkoutStatus.hidden = false;
    window.clearTimeout(statusTimer);
    statusTimer = window.setTimeout(() => { checkoutStatus.hidden = true; }, 6500);
  };

  const checkoutUrlForCart = (cart) => {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return '';
    const lines = cart.items.map((item) => `${item.variant_id}:${item.quantity}`).join(',');
    return `${window.location.origin}/cart/${lines}`;
  };

  const cacheCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((response) => {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    })
    .then((cart) => {
      latestCart = cart;
      const url = checkoutUrlForCart(cart);
      if (checkout && url) checkout.src = url;
      return cart;
    });

  if (checkout) {
    cacheCart().catch(() => {});

    const cartItems = document.querySelector('[data-nw-cart-items]');
    if (cartItems && 'MutationObserver' in window) {
      let cartRefreshTimer = null;
      new MutationObserver(() => {
        window.clearTimeout(cartRefreshTimer);
        cartRefreshTimer = window.setTimeout(() => { cacheCart().catch(() => {}); }, 80);
      }).observe(cartItems, { childList: true, subtree: true });
    }

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-embedded-checkout], [data-nw-checkout]');
      if (!trigger) return;
      const checkoutUrl = checkoutUrlForCart(latestCart) || checkout.getAttribute('src');
      if (!checkoutUrl || typeof checkout.open !== 'function') return;
      event.preventDefault();
      checkout.src = checkoutUrl;
      try {
        checkout.open();
      } catch (error) {
        showCheckoutStatus('Checkout could not open here. Use the secure checkout link again to continue in a new tab.');
      }
    });

    checkout.addEventListener('checkout:start', () => {
      showCheckoutStatus('Secure Shopify checkout is open. This Nanawala page will stay right here.');
    });

    checkout.addEventListener('checkout:complete', () => {
      showCheckoutStatus('Thank you. Your Nanawala order is complete.');
      fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(() => {
          latestCart = { items: [], item_count: 0 };
          document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = '0'; });
        })
        .catch(() => {});
    });

    checkout.addEventListener('checkout:error', () => {
      showCheckoutStatus('Shopify checkout had trouble loading. Your cart is safe; use the checkout link again to retry.');
    });

    document.addEventListener('nanawala:cart-updated', (event) => {
      if (!event.detail || !event.detail.cart) return;
      latestCart = event.detail.cart;
      const url = checkoutUrlForCart(latestCart);
      if (url) checkout.src = url;
    });
  }
})();
